import type { AgeAnswerModel } from '@/common/models/quiz.model';
import { useFacebookPixel } from '~/composables/facebookPixel.ts';

export function useSelectAge() {
  const selectedAge = ref<number>();
  const { $db, $mixpanel, $versions } = useNuxtApp();
  const { mixpanelTrack } = useMixpanel();
  const { track } = useRedTrack();
  const { fbqCustomTrack } = useFacebookPixel();
  const { openReplayTracker } = useOpenReplay();
  const router = useRouter();
  const route = useRoute();

  const select = async (age: AgeAnswerModel, index: number): Promise<void> => {
    await router.replace({ query: { ...route.query, age: String(age.id) } });
    selectedAge.value = index;
    if ($versions?.value.trackOnlyAfterQuiz !== '0') {
      $mixpanel?.people.set({ 'Age Group': age.name });
      mixpanelTrack('Quiz Started');
    }
    fbqCustomTrack('Quiz_Started');
    track('Quiz Started');
    openReplayTracker().event('Quiz Started');
    await $db?.setItem('compatibilityScore', age.compatibilityScore);
    await $db?.setItem('selectedAge', age.name.replace(' >', ''));
    await $db?.setItem('selectedAgeID', age.id);
  };

  return {
    selectedAge,
    select,
  };
}
